import React from 'react';

const About = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-16">
      <div className="max-w-4xl mx-auto px-4">
        <div className="bg-white rounded-lg shadow-lg p-8">
          <h1 className="text-4xl font-bold text-hacettepe-blue mb-8">Hakkımızda</h1>
          
          <div className="prose prose-lg max-w-none">
            <p className="text-gray-700 leading-relaxed mb-6">
              Hacettepe Üniversitesi Fen Fakültesi, 1967 yılında kurulan ve Türkiye'nin en köklü 
              eğitim kurumlarından biri olan Hacettepe Üniversitesi'nin önemli bir parçasıdır.
            </p>
            
            <h2 className="text-2xl font-semibold text-hacettepe-blue mb-4">Misyonumuz</h2>
            <p className="text-gray-700 leading-relaxed mb-6">
              Bilim ve teknolojinin ışığında, evrensel değerleri benimseyen, araştırma ve geliştirme 
              faaliyetlerinde öncü olan, nitelikli insan gücü yetiştiren bir fakülte olmak.
            </p>
            
            <h2 className="text-2xl font-semibold text-hacettepe-blue mb-4">Vizyonumuz</h2>
            <p className="text-gray-700 leading-relaxed mb-6">
              Ulusal ve uluslararası düzeyde tanınan, bilimsel araştırmalarda öncü, topluma hizmet 
              eden bir fakülte olarak gelecek nesillere ışık tutmak.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About; 